import { useApi } from "../../app/services.js";
import { useResource } from "../../lib/useResource.js";
import { ErrorNote, Spinner } from "../../ui/index.js";

/** The full text of a message. Loaded once: the text never changes, so screens that poll leave it alone. */
export function OriginalMessage({ messageId, className }: { messageId: string; className?: string }) {
  const api = useApi();
  const { resource, reload } = useResource(async () => (await api.call("messageText", { params: { id: messageId } })).text, [api, messageId]);

  if (resource.status === "loading") return <Spinner />;
  if (resource.status === "error") return <ErrorNote message={resource.message} onRetry={() => void reload()} />;
  if (resource.data.trim() === "") return <p className="muted small">This email has no text.</p>;
  return <div className={className === undefined ? "message-text" : `message-text ${className}`}>{resource.data}</div>;
}
